import { useMemo, useState } from 'react';
import { add } from 'date-fns';
import { OrderItem } from '../hooks/useOrder';
import { OrderItemReturnPolicy } from '../constants';

const FULL_COVERAGE_DAYS = 28;
const MARKDOWN_COVERAGE_DAYS = 14;
const NO_COVERAGE_DAYS = 0;

const FullCoveragePolicies: OrderItemReturnPolicy[] = [
  OrderItemReturnPolicy.ExtendedHolidays,
  OrderItemReturnPolicy.FullRefund,
  OrderItemReturnPolicy.SiteCreditOnly
];

const MarkdownCoveragePolicies: OrderItemReturnPolicy[] = [
  OrderItemReturnPolicy.FullRefundMarkdown,
  OrderItemReturnPolicy.FullRefundPromo,
  OrderItemReturnPolicy.SiteCreditOnlyMarkdown
];

export const useIsFineJewelryReturnPolicyCovered = (item?: OrderItem) => {
  const [category] = useState<string | undefined>(item?.attributes.category);
  const [policy] = useState<OrderItemReturnPolicy>(
    typeof item?.attributes.returnPolicy !== 'undefined'
      ? item?.attributes.returnPolicy
      : OrderItemReturnPolicy.NotEligibleForReturn
  );
  const [shippedOn] = useState<string | null | undefined>(item?.attributes.shippedOn);

  const isFineJewelry = useMemo(() => category === 'FINE_JEWELRY', [category]);

  const coverage = useMemo(() => {
    if (!isFineJewelry || !shippedOn) return null;

    if (FullCoveragePolicies.includes(policy)) {
      return FULL_COVERAGE_DAYS;
    }

    if (MarkdownCoveragePolicies.includes(policy)) {
      return MARKDOWN_COVERAGE_DAYS;
    }

    return NO_COVERAGE_DAYS;
  }, [isFineJewelry, policy, shippedOn]);

  const isFineJewelryReturnPolicyCovered = useMemo(
    () =>
      shippedOn && coverage ? add(new Date(shippedOn), { days: coverage }) > new Date() : false,
    [coverage, shippedOn]
  );

  return isFineJewelryReturnPolicyCovered;
};
